import { http } from './request';
import request from './request';
import type { DataExport, CreateExportRequest } from '../types/lifecycle';

// 导出相关 API
export const exportApi = {
  // 创建导出任务
  create: (exportType: CreateExportRequest['export_type'], format: CreateExportRequest['format']) =>
    http.post<DataExport>('/api/v1/exports', {
      export_type: exportType,
      format,
    } as CreateExportRequest),

  // 获取导出列表
  getList: (page = 1, pageSize = 10) =>
    http.get<{ items: DataExport[]; total: number }>('/api/v1/exports', {
      page,
      page_size: pageSize,
    }),

  // 下载导出文件
  download: async (id: number): Promise<Blob> => {
    const response = await request.get(`/api/v1/exports/${id}/download`, {
      responseType: 'blob',
    });
    return response.data;
  },
};

export default exportApi;
